export const BODY_SIZE_SMALL = '608px';
export const BODY_SIZE_MEDIUM = '800px';
export const BODY_SIZE_FULL = '100%';
